import * as React from "react";
const PrevArrowSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <path
      fill="var(--color-primary)"
      fillRule="nonzero"
      d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-3.707 16.707 4.5 4.5a.997.997 0 0 0 .707.293c.883 0 1.339-1.075.707-1.707L14.414 16l3.793-3.793a1 1 0 0 0-1.414-1.414l-4.5 4.5a1 1 0 0 0 0 1.414z"
    />
  </svg>
);
export default PrevArrowSvg;
